module.exports = __webpack_public_path__ + "static/pendulumPic-ff6fe5b2e629175ca46b7e8f77ddc843.png";